/* @flow */
import { combineReducers } from 'redux';

import roleBasedMessagingSearch from 'reducers/roleBasedMessagingSearch';
import organizationClassesTables from 'reducers/organizationClassesTables';
import connectionStateBanner from 'reducers/connectionStateBanner';
import tables from 'reducers/tables';
import banners from 'reducers/banners';
import toasts from 'reducers/toasts';
import recentMessagesModal from 'reducers/recentMessagesModal';
import adminUpgradePage from 'admin/reducers/adminUpgradePage';
import peopleTables from 'reducers/peopleTables';
import schoolTables from 'reducers/schoolTables';
import phoneCalls from 'phoneCalls/reducers/phoneCalls';
import floatingBoxes from 'reducers/floatingBoxes';
import modals from 'reducers/modals';
import touch from 'reducers/touch';
import streamReadMarkerPush from 'reducers/StreamReadMarkerPush';
import creditCards from 'reducers/creditCards';
import directAddForm from 'reducers/directAddForm';

const globalReducers = {
  roleBasedMessagingSearch,
  connectionStateBanner,
  organizationClassesTables,
  adminUpgradePage,
  streamReadMarkerPush,
  schoolTables,
  banners,
  toasts,
  touch,
  modals,
  tables,
  floatingBoxes,
  recentMessagesModal,
  peopleTables,
  phoneCalls,
  creditCards,
  directAddForm,
};
/*
) => CombinedReducer<
  $ObjMap<
    {|
      adminUpgradePage: (
        state?: State,
        action: any
      ) => State,
      banners: (state?: State, action: any) => State,
      connectionStateBanner: (
        state?: State,
        action: any
      ) => State,
      creditCards: (state?: State, action: any) => State,
      directAddForm: (state?: State, action: any) => State,
      fileUploads: (state?: State, action: any) => State,
      floatingBoxes: (state?: State, action: any) => State,
      modals: (state?: State, action: any) => State,
      organizationClassesTables: (
        state?: State,
        action: any
      ) => State,
      peopleTables: (state?: State, action: any) => State,
      phoneCalls: (state?: State, action: any) => State,
      recentMessagesModal: (
        state?: State,
        action: any
      ) => State,
      roleBasedMessagingSearch: (
        state?: State,
        action: any
      ) => State,
      schoolTables: (state?: State, action: any) => State,
      streamReadMarkerPush: (
        state?: State,
        action: any
      ) => State,
      tables: (state?: State, action: any) => State,
      toasts: (state?: State, action: any) => State,
      touch: (state?: State, action: any) => State
    |},
    <S>(r: Reducer<S, any>) => S
  >,
  empty
>
      */

export default function combineRemindReducers() {
  // 0.98.0 upgrade note - infering here kept a type that was pretty bonkers but maybe useful?
  // it involved $ObjMap so decided not to carry it forward as it would not necessarily convert to TS easy
  // see above.
  return combineReducers<*, *>({
    ...globalReducers,
  });
}
